import request from '@/utils/request'
// 获取分组列表数据
export function getGroupList(params) {
  return request({
    url: '/auth_group/groups',
    method: 'get',
    params
  })
}

export function getGroupTreeList(params) {
  return request({
    url: '/auth_group/tree',
    method: 'get',
    params
  })
}

// export function getGroupChildrenList(id) {
//   return request({
//     url: `/auth_group/tree${id}`,
//     method: 'get'
//   })
// }
// 获取分组树结构
export function groupChildrenList() {
  return request({
    url: `/auth_group/tree`,
    method: 'get'
  })
}

// 分组详情
export function getGroupDetail(id) {
  return request({
    url: `/auth_group/groups/${id}`,
    method: 'get'
  })
}

export function createGroup(data) {
  return request({
    url: '/auth_group/groups',
    method: 'post',
    data
  })
}

export function updateGroup(id, data) {
  return request({
    url: `/auth_group/groups/${id}`,
    method: 'put',
    data
  })
}

export function deleteGroup(id) {
  return request({
    url: `/auth_group/groups/${id}`,
    method: 'delete'
  })
}

export function updateGroupSort(id, listorder) {
  return request({
    url: `/auth/group/${id}/sort`,
    method: 'patch',
    data: {
      listorder
    }
  })
}

export function enableGroup(id) {
  return request({
    url: `/auth/group/${id}/enable`,
    method: 'patch'
  })
}

export function disableGroup(id) {
  return request({
    url: `/auth/group/${id}/disable`,
    method: 'patch'
  })
}

export function updateGroupAccess(data) {
  return request({
    url: `/auth_group/access`,
    method: 'post',
    data
  })
}

// 设置组长
export function setUp(data = {}) {
  return request({
    url: `/auth_group/updateLeader`,
    method: 'post',
    data
  })
}
export function groupLeaders(params) {
  return request({
    url: `/auth_group/groupLeaders`,
    method: 'get',
    params
  })
}
export function deleteLeaders(data = {}) {
  return request({
    url: `/auth_group/deleteLeaders`,
    method: 'post',
    data
  })
}
